addEventListener("DOMContentLoaded", (event) => {
    const primaryMenu = document.querySelectorAll("#menu-main-menu li.menu-item-has-children");

    if (primaryMenu.length) {
        function donaldsons_theme_init_mega_menu() {
            [...primaryMenu].map((item) => {
                // get menu name and url to create the heading element
                const menuName = item.outerText;
                const url = item.children[0].href;

                // get sub-menu
                const subMenu = item.querySelector(".sub-menu");

                // create markup for heading and insert menu name and url
                const subMenuHeading = `
            <div class="sub-menu__heading">
                <h3>${menuName}</h3>
                <a class="arrow-link arrow-link--white" href="${url}"><span>View All Products</span></a>
            </div>
        `;

                // wrap the existing links with a div
                const wrappedLinks = `<div class="sub-menu__links-wrapper">${subMenu.innerHTML}</div>`;

                // update sub-menu innerHTML to include the wrapped links
                subMenu.innerHTML = wrappedLinks;

                // add the heading before the links wrapper
                subMenu.insertAdjacentHTML("afterbegin", subMenuHeading);

                const menuLogoUrl = `${JS_OBJ.temp_dir}/assets/img/logos/donaldsons-menu-logo.png`;

                const menuLogo = `<img src="${menuLogoUrl}" class="menu-logo" />`;

                // add donaldsons logo after links wrapper
                subMenu.insertAdjacentHTML("beforeend", menuLogo);
            });
        }
        donaldsons_theme_init_mega_menu();
    }
});
